<form class="mb-2" #familleForm="ngForm">

	<div class="p-fluid grid formgrid p-2">

		<div class="field-checkbox col-12">
			<p-checkbox
				name="fam_actif"
				inputId="fam_actif"
				[(ngModel)]="famille.fam_actif"
				[binary]="true"
				[label]="'families.active_state' | translate"
				[disabled]="!editMode"
			></p-checkbox>
		</div>

		<!-- Nom -->
		<div class="field col-6">
			<label for="fam_nom">
				{{ 'common.name_label' | translate }}
			</label>
			<input
				type="text"
				pInputText
				name="fam_nom"
				[(ngModel)]="famille.fam_nom"
				[attr.placeholder]="'common.name_label' | translate"
				[readOnly]="!editMode"
				required
			/>
		</div>

		<div class="col-12"></div>

		<!-- Description -->

		<div class="field col-12">
			<label for="fam_description">
				{{ 'common.description_label' | translate }}

			</label>
			<textarea
				pInputTextarea
				name="fam_description"
				[(ngModel)]="famille.fam_description"
				[autoResize]="true"
				[readOnly]="!editMode"
			></textarea>
		</div>

		<!-- Historique -->

		<div *ngIf="!isCreation && showHistorique" class="field col-12">
			<label for="history">
				{{ 'common.history_label' | translate }}
			</label>
			<div>
				<historique-element-nomenclature [element]="famille"></historique-element-nomenclature>
			</div>
		</div>

	</div>

	<div class="text-center">
		<!-- Bouton éditer -->
		<button
			*ngIf="!editMode && canEdit"
			type="button"
			pButton
			class="label-md-none"
			[label]="'common.edition_button_label' | translate"
			icon="pi pi-pencil"
			(click)="toggleEditMode()"
		></button>

		<!-- Bouton enregistrer -->
		<button
			*ngIf="!!editMode"
			type="button"
			pButton
			class="label-md-none"
			[label]="'common.save_button_label' | translate"
			icon="pi pi-save"
			(click)="submit()"
			[disabled]="!familleForm.valid"
		></button>
	</div>
</form>
